<template>
  <path pid="0" d="M10 11v-.12A1 1 0 009 10H5.52l2.81-2.64a8 8 0 11-1.88 8.3 1 1 0 10-1.88.66A10 10 0 1018.84 4.25l-.27-.14A10 10 0 006.93 5.92L4 8.68V5a1 1 0 00-2 0v6a.53.53 0 000 .13V11.25c0 .02 0 0 0 0a.43.43 0 000 .05V11.47l.06.08a.39.39 0 00.1.08.75.75 0 00.3.17H9a1 1 0 001-.8zM2.27 9.29zM2.62 10l-.08-.1z"/>
</template>
